import { render, staticRenderFns } from "./enameledWireMateBarBind.vue?vue&type=template&id=2c7c4d40&scoped=true"
import script from "./enameledWireMateBarBind.vue?vue&type=script&lang=js"
export * from "./enameledWireMateBarBind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7c4d40",
  null
  
)

export default component.exports